export default __webpack_public_path__ + "static/media/oscer-icon-solid.66a4ace1.svg";